
import HeaderCom from "~/components/header.vue";
import FooterCom from "~/components/footer.vue";
import AuthenticationAlert from "~/components/authenticationAlert.vue";
import ReapplyAlert from "~/components/reapplyAlert.vue";
import LoginAlert from "@/components/login/loginAlert";
import LoadingModule from "@/components/loading";
import rightNav from '@/components/rightNav.vue';
import {userInfo} from "@/api/myapps";
import { setToken, removeToken } from '@/utils/auth';
import inquiryAlert from '@/components/login/inquiryAlert'
import {creatUdid} from "~/utils/creatUdid";

export default {
  components: {
    HeaderCom,
    FooterCom,
    AuthenticationAlert,
    LoginAlert,
    LoadingModule,
    ReapplyAlert,
    rightNav,
    inquiryAlert,
  },
  created(){
    this.$store.commit('LOADING_STATE', true);
  },
  mounted(){
    creatUdid()
    // 判断是否登录
    userInfo().then(res=>{
        if(res.code === 401){
          removeToken();
          setToken('');
        }
        if(res.code === 0){
          this.$store.commit('USER_INFO', res.data);
        }
        this.$store.commit('LOADING_STATE', false); //全局loading
    }).catch(()=>{
      this.$store.commit('LOADING_STATE', false);//全局loading
    })
  }
}
